<template>
  <div>
    <div class="toolbar">
      <el-select v-model="projectId" clearable filterable placeholder="项目" style="width:200px" @change="load">
        <el-option v-for="p in projects" :key="p.id" :label="projectLabel(p)" :value="p.id" />
      </el-select>
      <el-select v-model="supplierId" clearable filterable placeholder="供应商" style="width:180px" @change="load">
        <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
      </el-select>
      <el-select v-model="status" clearable placeholder="审核状态" style="width:130px" @change="load">
        <el-option v-for="o in materialReqStatusFilterOptions" :key="o.value" :label="o.label" :value="o.value" />
      </el-select>
      <el-select v-model="receiveStatus" clearable placeholder="收货状态" style="width:130px" @change="load">
        <el-option v-for="(v,k) in materialReceiveStatusMap" :key="k" :label="v.label" :value="k" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新建申请</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading" show-summary :summary-method="listAmountSummary">
      <el-table-column prop="reqNo" label="单号" width="160" />
      <el-table-column prop="projectName" label="项目" min-width="140">
        <template slot-scope="{ row }">
          <project-name-link :project-id="row.projectId" :name="row.projectName" />
        </template>
      </el-table-column>
      <el-table-column prop="projectAddress" label="项目地址" min-width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.projectAddress || '-' }}</template>
      </el-table-column>
      <el-table-column prop="stageName" label="工序" width="110" />
      <el-table-column prop="supplierName" label="供应商" min-width="130" />
      <el-table-column prop="totalAmount" label="申请金额" width="100" align="right">
        <template slot-scope="{ row }">{{ formatMoney(row.totalAmount) }}</template>
      </el-table-column>
      <el-table-column prop="actualCostAmount" label="采购金额" width="100" align="right">
        <template slot-scope="{ row }">{{ formatMoney(row.actualCostAmount) }}</template>
      </el-table-column>
      <el-table-column prop="actualSaleAmount" label="销售金额" width="100" align="right">
        <template slot-scope="{ row }">{{ formatMoney(row.actualSaleAmount != null ? row.actualSaleAmount : row.actualTotalAmount) }}</template>
      </el-table-column>
      <el-table-column prop="status" label="审核状态" width="80">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(materialReqStatusMap, row.status)">
            {{ statusLabel(materialReqStatusMap, row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="receiveStatus" label="收货状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(materialReceiveStatusMap, row.receiveStatus || 'NONE')">
            {{ statusLabel(materialReceiveStatusMap, row.receiveStatus || 'NONE') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdByName" label="创建人" width="90" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createdByName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="90">
        <template slot-scope="{ row }">{{ formatDateOnly(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="250" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">详情</el-button>
          <el-button
            type="text"
            :disabled="!(row.status==='SUBMITTED'||row.status==='REJECTED'||row.status==='DRAFT')"
            @click="openEdit(row)"
          >编辑</el-button>
          <el-button
            type="text"
            :disabled="row.status==='APPROVED'
              ? !isReceiveNone(row)
              : row.status!=='SUBMITTED'"
            @click="row.status==='APPROVED' ? onUnapprove(row) : onApprove(row)"
          >{{ row.status==='APPROVED' ? '反审' : '审批' }}</el-button>
          <el-button
            type="text"
            class="op-danger"
            :disabled="row.status!=='SUBMITTED'"
            @click="onReject(row)"
          >驳回</el-button>
          <el-button
            type="text"
            :disabled="!(row.status==='APPROVED' && row.receiveStatus!=='FULL')"
            @click="onReceive(row)"
          >收货</el-button>
          <el-button
            type="text"
            class="op-danger"
            :disabled="!(row.status==='SUBMITTED'||row.status==='REJECTED'||row.status==='DRAFT')"
            @click="onDelete(row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id?'编辑材料申请':'新建材料申请'" :visible.sync="visible" width="1080px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="项目" required>
          <el-select v-model="form.projectId" filterable style="width:100%" @change="onProjectChange">
            <el-option v-for="p in projects" :key="p.id" :label="projectLabel(p)" :value="p.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="caps.reqStageRequired" label="工序" required>
          <el-select v-model="form.projectStageId" filterable style="width:100%" placeholder="请选择">
            <el-option v-for="s in stages" :key="s.id" :label="s.stageName" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="供应商" required>
          <el-select v-model="form.supplierId" filterable style="width:100%" @change="onReqSupplierChange">
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="使用日期" required>
          <el-date-picker
            v-model="form.needDate"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:100%"
            @change="onNeedDateChange"
          />
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
        <el-form-item label="明细" required>
          <el-button size="mini" type="primary" plain @click="openPickMaterial">选择材料</el-button>
          <el-table :data="form.lines" border size="small" style="margin-top:8px">
            <el-table-column prop="materialName" label="材料" min-width="120" show-overflow-tooltip />
            <el-table-column prop="spec" label="规格" width="100" show-overflow-tooltip />
            <el-table-column prop="unit" label="单位" width="70" align="center" />
            <el-table-column label="采购单价" width="120">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.costPrice"
                  :min="0"
                  :precision="2"
                  :step="1"
                  size="mini"
                  controls-position="right"
                  style="width:100%"
                />
              </template>
            </el-table-column>
            <el-table-column label="销售单价" width="120">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.salePrice"
                  :min="0"
                  :precision="2"
                  :step="1"
                  size="mini"
                  controls-position="right"
                  style="width:100%"
                />
              </template>
            </el-table-column>
            <el-table-column label="数量" width="120">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.qty" :min="0.01" :precision="2" size="mini" controls-position="right" style="width:100%" />
              </template>
            </el-table-column>
            <el-table-column label="采购金额" width="100" align="right">
              <template slot-scope="{ row }">{{ formatMoney(lineCostSubtotal(row)) }}</template>
            </el-table-column>
            <el-table-column label="销售金额" width="100" align="right">
              <template slot-scope="{ row }">{{ formatMoney(lineSaleSubtotal(row)) }}</template>
            </el-table-column>
            <el-table-column width="60" fixed="right">
              <template slot-scope="{ $index }">
                <el-button type="text" style="color:#ef4444" @click="form.lines.splice($index,1)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
          <p class="tip">从材料档案选择；单价优先取该供应商有效价格表，否则取档案参考价，可手动调整。</p>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="选择材料"
      :visible.sync="pickVisible"
      width="760px"
      append-to-body
      @closed="onPickClosed"
    >
      <div class="pick-toolbar">
        <el-input
          v-model="pickKeyword"
          clearable
          placeholder="名称 / 规格 / 分类"
          style="width:240px"
          @keyup.enter.native="loadPickList"
        />
        <el-button type="primary" icon="el-icon-search" @click="loadPickList">查询</el-button>
      </div>
      <el-table
        ref="pickTable"
        :data="pickPageList"
        border
        size="small"
        row-key="id"
        v-loading="pickLoading"
        max-height="420"
        @selection-change="onPickSelectionChange"
      >
        <el-table-column type="selection" width="45" :selectable="pickSelectable" reserve-selection />
        <el-table-column prop="name" label="材料名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="分类" width="110" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.categoryName || row.category || '-' }}</template>
        </el-table-column>
        <el-table-column prop="spec" label="规格" width="110" show-overflow-tooltip />
        <el-table-column prop="unit" label="单位" width="70" align="center" />
        <el-table-column label="采购单价" width="100" align="right">
          <template slot-scope="{ row }">{{ formatMoney(row.costPrice) }}</template>
        </el-table-column>
        <el-table-column label="销售单价" width="100" align="right">
          <template slot-scope="{ row }">{{ formatMoney(row.salePrice) }}</template>
        </el-table-column>
      </el-table>
      <list-pagination
        :total="pickTotal"
        :page="pickPage"
        :page-size="pickPageSize"
        @current-change="onPickPageChange"
        @size-change="onPickPageSizeChange"
      />
      <div slot="footer">
        <el-button @click="pickVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmPickMaterials">确定</el-button>
      </div>
    </el-dialog>

    <el-drawer title="申请详情" :visible.sync="detailVisible" size="960px">
      <div style="padding:0 16px 16px" v-if="detail">
        <div class="detail-meta">
          <span>单号：{{ detail.req.reqNo }}</span>
          <span>项目：{{ detail.req.projectName }}{{ detail.req.stageName ? ' / ' + detail.req.stageName : '' }}</span>
          <span>供应商：{{ detail.req.supplierName || '-' }}</span>
          <span>申请人：{{ detail.req.createdByName || '-' }}</span>
          <span>申请日期：{{ formatDateOnly(detail.req.createdAt) }}</span>
          <span>申请金额：{{ formatMoney(detail.req.totalAmount) }}</span>
          <span>审核：{{ statusLabel(materialReqStatusMap, detail.req.status) }}</span>
          <span>收货：{{ statusLabel(materialReceiveStatusMap, detail.req.receiveStatus || 'NONE') }}</span>
        </div>
        <el-table
          :data="detail.lines"
          border
          size="small"
          show-summary
          :summary-method="detailLineSummary"
        >
          <el-table-column prop="materialName" label="材料" min-width="110" />
          <el-table-column label="规格" min-width="100" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ lineSpec(row) }}</template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="60" />
          <el-table-column prop="qty" label="数量" width="70" align="right" />
          <el-table-column prop="receivedQty" label="已收" width="70" align="right" />
          <el-table-column prop="returnedQty" label="已退" width="70" align="right" />
          <el-table-column prop="actualQty" label="实收" width="70" align="right" />
          <el-table-column prop="costPrice" label="采购单价" width="90" align="right">
            <template slot-scope="{ row }">{{ formatMoney(row.costPrice) }}</template>
          </el-table-column>
          <el-table-column prop="price" label="销售单价" width="90" align="right">
            <template slot-scope="{ row }">{{ formatMoney(row.price) }}</template>
          </el-table-column>
          <el-table-column prop="costAmount" label="采购金额" width="90" align="right">
            <template slot-scope="{ row }">{{ formatMoney(lineCostAmount(row)) }}</template>
          </el-table-column>
          <el-table-column prop="saleAmount" label="销售金额" width="90" align="right">
            <template slot-scope="{ row }">{{ formatMoney(lineSaleAmount(row)) }}</template>
          </el-table-column>
        </el-table>
        <p style="margin-top:16px;font-weight:600">收货明细</p>
        <el-table :data="receiveLines" border size="small" empty-text="暂无收货明细">
          <el-table-column prop="receiveNo" label="收货单号" min-width="130" />
          <el-table-column prop="materialName" label="材料" min-width="120" />
          <el-table-column label="规格" min-width="100" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ lineSpec(row) }}</template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="receiveQty" label="本次收货" width="90" />
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
          </el-table-column>
          <el-table-column prop="createdAt" label="收货时间" width="170" />
          <el-table-column prop="createdByName" label="操作人" width="90" />
        </el-table>
        <p style="margin-top:16px;font-weight:600">退货明细</p>
        <el-table :data="returnLines" border size="small" empty-text="暂无退货明细">
          <el-table-column prop="returnNo" label="退货单号" min-width="130" />
          <el-table-column prop="materialName" label="材料" min-width="120" />
          <el-table-column label="规格" min-width="100" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ lineSpec(row) }}</template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="qty" label="本次退货" width="90" />
          <el-table-column prop="status" label="状态" width="90">
            <template slot-scope="{ row }">
              {{ statusLabel(materialReturnStatusMap, row.status) }}
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="退货时间" width="170" />
          <el-table-column prop="createdByName" label="操作人" width="90" />
        </el-table>
      </div>
    </el-drawer>

    <el-dialog title="材料收货" :visible.sync="receiveVisible" width="70%">
      <p v-if="receiveForm.reqNo" class="tip" style="margin-top:0">申请单：{{ receiveForm.reqNo }} · 本次未送材料可删行，下次再收</p>
      <el-table :data="receiveForm.lines" border size="small" v-loading="receiveLoading">
        <el-table-column prop="materialName" label="材料" min-width="140" />
        <el-table-column prop="spec" label="规格" width="110" show-overflow-tooltip />
        <el-table-column prop="unit" label="单位" width="70" />
        <el-table-column prop="reqQty" label="申请数量" width="90" />
        <el-table-column prop="receivedQty" label="已收" width="80" />
        <el-table-column prop="remainQty" label="可收" width="80" />
        <el-table-column label="本次收货" width="140">
          <template slot-scope="{ row }">
            <el-input-number
              v-model="row.receiveQty"
              :min="0"
              :max="Number(row.remainQty)"
              :precision="2"
              size="mini"
              controls-position="right"
            />
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="150">
          <template slot-scope="{ row }">
            <el-input v-model="row.remark" size="mini" placeholder="选填" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70" fixed="right">
          <template slot-scope="{ $index }">
            <el-button type="text" style="color:#ef4444" @click="removeReceiveLine($index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-form style="margin-top:12px" label-width="60px">
        <el-form-item label="备注"><el-input v-model="receiveForm.remark" placeholder="整单备注（选填）" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="receiveVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="fillAllRemain">全部可收</el-button>
        <el-button type="primary" :loading="saving" @click="saveReceive">生成收货单</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listMaterialReqs, getMaterialReq, saveMaterialReq,
  approveMaterialReq, unapproveMaterialReq, rejectMaterialReq, deleteMaterialReq,
  previewMaterialReceive, createMaterialReceive, listMaterialReceiveLines,
  listMaterialReturnLines, listSuppliers, listConfirmedMaterials, listMaterials
} from '../../api/supply'
import { listProjects, getProject } from '../../api/project'
import {
  materialReqStatusMap, materialReceiveStatusMap, materialReturnStatusMap,
  materialReqStatusFilterOptions,
  statusLabel, statusType
} from '../../utils/status'
import ListPagination from '../../components/ListPagination.vue'
import ProjectNameLink from '../../components/ProjectNameLink.vue'
import listPaging from '../../mixins/listPaging'
import { planCapabilities } from '../../utils/plan'
import { mapState } from 'vuex'

export default {
  name: 'MaterialRequisition',
  components: { ListPagination, ProjectNameLink },
  mixins: [listPaging],
  data() {
    return {
      materialReqStatusMap,
      materialReqStatusFilterOptions,
      materialReceiveStatusMap,
      materialReturnStatusMap,
      projectId: null, supplierId: null, status: '', receiveStatus: '',
      projects: [], suppliers: [], stages: [],
      materialPriceMap: {},
      list: [], loading: false, saving: false,
      visible: false, form: { lines: [] },
      pickVisible: false,
      pickKeyword: '',
      pickList: [],
      pickLoading: false,
      pickPage: 1,
      pickPageSize: 15,
      pickSelection: [],
      detailVisible: false, detail: null, receiveLines: [], returnLines: [],
      receiveVisible: false, receiveLoading: false,
      receiveForm: { reqId: null, reqNo: '', remark: '', lines: [] }
    }
  },
  computed: {
    ...mapState(['user']),
    caps() {
      return planCapabilities(this.user)
    },
    pickPageList() {
      const list = this.pickList || []
      const start = (this.pickPage - 1) * this.pickPageSize
      return list.slice(start, start + this.pickPageSize)
    },
    pickTotal() {
      return (this.pickList || []).length
    },
    selectedMaterialIds() {
      return new Set((this.form.lines || []).map(l => l.materialId).filter(Boolean))
    }
  },
  created() {
    this.loadMeta()
    const pid = Number(this.$route.query.projectId)
    if (pid) this.projectId = pid
    if (this.$route.query.status) this.status = this.$route.query.status
    if (this.$route.query.receiveStatus) this.receiveStatus = this.$route.query.receiveStatus
    this.load()
  },
  methods: {
    statusLabel, statusType,
    projectLabel(p) {
      return (p && (p.name || p.customerName)) || ''
    },
    formatMoney(v) {
      if (v == null || v === '') return '0.00'
      const n = Number(v)
      return Number.isFinite(n) ? n.toFixed(2) : '0.00'
    },
    formatDateOnly(v) {
      if (!v) return '-'
      const s = String(v).replace('T', ' ')
      return s.length >= 10 ? s.slice(0, 10) : s
    },
    lineSpec(row) {
      if (!row) return '-'
      return row.specs || row.spec || '-'
    },
    listAmountSummary({ columns }) {
      const sums = []
      const moneyProps = ['totalAmount', 'actualCostAmount', 'actualSaleAmount']
      const rows = this.list || []
      columns.forEach((col, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const prop = col.property
        if (!moneyProps.includes(prop)) {
          sums[index] = ''
          return
        }
        const total = rows.reduce((s, row) => {
          if (prop === 'actualSaleAmount') {
            return s + (Number(row.actualSaleAmount != null ? row.actualSaleAmount : row.actualTotalAmount) || 0)
          }
          return s + (Number(row[prop]) || 0)
        }, 0)
        sums[index] = this.formatMoney(total)
      })
      return sums
    },
    formatQty(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '0'
      return Number.isInteger(n) ? String(n) : n.toFixed(2)
    },
    lineCostAmount(row) {
      return (Number(row && row.actualQty) || 0) * (Number(row && row.costPrice) || 0)
    },
    lineSaleAmount(row) {
      return (Number(row && row.actualQty) || 0) * (Number(row && row.price) || 0)
    },
    detailLineSummary({ columns, data }) {
      const sums = []
      const qtyProps = ['qty', 'receivedQty', 'returnedQty', 'actualQty']
      const moneyProps = ['costAmount', 'saleAmount']
      columns.forEach((col, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const prop = col.property
        if (!prop || (!qtyProps.includes(prop) && !moneyProps.includes(prop))) {
          sums[index] = ''
          return
        }
        const total = (data || []).reduce((s, row) => {
          if (prop === 'costAmount') return s + this.lineCostAmount(row)
          if (prop === 'saleAmount') return s + this.lineSaleAmount(row)
          return s + (Number(row[prop]) || 0)
        }, 0)
        sums[index] = moneyProps.includes(prop) ? this.formatMoney(total) : this.formatQty(total)
      })
      return sums
    },
    lineCostSubtotal(row) {
      return (Number(row.qty) || 0) * (Number(row.costPrice) || 0)
    },
    lineSaleSubtotal(row) {
      return (Number(row.qty) || 0) * (Number(row.salePrice) || 0)
    },
    async loadMeta() {
      const [p, s] = await Promise.all([listProjects({}), listSuppliers({})])
      this.projects = p.data || []
      this.suppliers = (s.data || []).filter(x => x.enabled !== 0)
    },
    async load() {
      this.loading = true
      try {
        const res = await listMaterialReqs({
          projectId: this.projectId || undefined,
          supplierId: this.supplierId || undefined,
          status: this.status || undefined,
          receiveStatus: this.receiveStatus || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally { this.loading = false }
    },
    async onProjectChange(id) {
      this.form.projectStageId = null
      if (!id) { this.stages = []; return }
      const res = await getProject(id)
      this.stages = (res.data && res.data.stages) || []
    },
    async onReqSupplierChange(id) {
      await this.reloadMaterialPrices()
      this.refreshLinePrices()
    },
    async onNeedDateChange() {
      if (!this.form.supplierId) return
      await this.reloadMaterialPrices()
      this.refreshLinePrices()
    },
    async reloadMaterialPrices() {
      const id = this.form.supplierId
      if (!id) {
        this.materialPriceMap = {}
        return
      }
      const res = await listConfirmedMaterials(id, this.form.needDate || undefined)
      const map = {}
      ;(res.data || []).forEach(m => {
        map[m.id] = {
          costPrice: Number(m.costPrice) || 0,
          salePrice: Number(m.price) || 0
        }
      })
      this.materialPriceMap = map
    },
    refreshLinePrices() {
      if (!this.form.lines || !this.form.lines.length) return
      this.form.lines.forEach(l => {
        if (!l.materialId) return
        const p = this.materialPriceMap[l.materialId]
        if (p) {
          l.costPrice = p.costPrice
          l.salePrice = p.salePrice
        }
      })
    },
    lineFromMaterial(m) {
      const p = this.materialPriceMap[m.id]
      return {
        materialId: m.id,
        materialName: m.name || '',
        spec: m.spec || '',
        unit: m.unit || '',
        costPrice: p ? p.costPrice : (Number(m.costPrice) || 0),
        salePrice: p ? p.salePrice : (Number(m.salePrice) || 0),
        qty: 1
      }
    },
    async openPickMaterial() {
      if (this.form.supplierId) {
        await this.reloadMaterialPrices()
      }
      this.pickKeyword = ''
      this.pickSelection = []
      this.pickPage = 1
      this.pickVisible = true
      await this.loadPickList()
    },
    async loadPickList() {
      this.pickLoading = true
      try {
        const res = await listMaterials({ keyword: this.pickKeyword || undefined })
        this.pickList = (res.data || []).filter(m => m.enabled !== 0)
        this.pickPage = 1
        this.pickSelection = []
        this.$nextTick(() => {
          if (this.$refs.pickTable) this.$refs.pickTable.clearSelection()
        })
      } finally {
        this.pickLoading = false
      }
    },
    pickSelectable(row) {
      return !this.selectedMaterialIds.has(row.id)
    },
    onPickSelectionChange(rows) {
      this.pickSelection = rows || []
    },
    onPickPageChange(p) {
      this.pickPage = p
    },
    onPickPageSizeChange(s) {
      this.pickPageSize = s
      this.pickPage = 1
    },
    onPickClosed() {
      this.pickSelection = []
      this.pickList = []
    },
    confirmPickMaterials() {
      const selected = this.pickSelection || []
      if (!selected.length) {
        return this.$message.warning('请先勾选材料')
      }
      let added = 0
      selected.forEach(m => {
        if (!m || !m.id || this.selectedMaterialIds.has(m.id)) return
        this.form.lines.push(this.lineFromMaterial(m))
        added += 1
      })
      if (!added) {
        return this.$message.warning('所选材料已在明细中')
      }
      this.pickVisible = false
      this.$message.success(`已添加 ${added} 个材料`)
    },
    async openEdit(row) {
      if (!row) {
        this.form = {
          id: null,
          projectId: null,
          projectStageId: null,
          supplierId: null,
          needDate: '',
          remark: '',
          lines: []
        }
        this.stages = []
        this.materialPriceMap = {}
        this.visible = true
        return
      }
      const res = await getMaterialReq(row.id)
      const d = res.data || {}
      const r = d.req || {}
      this.form = {
        id: r.id,
        projectId: r.projectId,
        projectStageId: r.projectStageId,
        supplierId: r.supplierId,
        needDate: (r.needDate || '').toString().slice(0, 10),
        remark: r.remark,
        lines: (d.lines || []).map(l => ({
          materialId: l.materialId,
          materialName: l.materialName || '',
          spec: l.specs || l.spec || '',
          unit: l.unit || '',
          qty: Number(l.qty),
          costPrice: l.costPrice != null ? Number(l.costPrice) : 0,
          salePrice: l.price != null ? Number(l.price) : 0
        }))
      }
      await this.onProjectChange(r.projectId)
      this.form.projectStageId = r.projectStageId
      await this.reloadMaterialPrices()
      this.visible = true
    },
    async openDetail(row) {
      const [res, recv, ret] = await Promise.all([
        getMaterialReq(row.id),
        listMaterialReceiveLines(row.id).catch(() => ({ data: [] })),
        listMaterialReturnLines(row.id).catch(() => ({ data: [] }))
      ])
      this.detail = res.data
      this.receiveLines = recv.data || []
      this.returnLines = ret.data || []
      this.detailVisible = true
    },
    async save() {
      const f = this.form
      if (!f.projectId || !f.supplierId) return this.$message.warning('请选择项目和供应商')
      if (this.caps.reqStageRequired && !f.projectStageId) return this.$message.warning('请选择工序')
      if (!f.needDate) return this.$message.warning('请选择使用日期')
      if (!f.lines.length || f.lines.some(l => !l.materialId || !l.qty)) return this.$message.warning('请完善明细')
      this.saving = true
      try {
        await saveMaterialReq({
          id: f.id,
          projectId: f.projectId,
          projectStageId: f.projectStageId,
          supplierId: f.supplierId,
          needDate: f.needDate,
          remark: f.remark,
          lines: f.lines.map(l => ({
            materialId: l.materialId,
            qty: l.qty,
            specs: l.spec || undefined,
            costPrice: l.costPrice,
            price: l.salePrice
          }))
        })
        this.$message.success('已保存，等待审批')
        this.visible = false
        this.load()
      } finally { this.saving = false }
    },
    onApprove(row) {
      this.$confirm('确认审批通过？', '审批').then(async () => {
        await approveMaterialReq(row.id); this.$message.success('已审批'); this.load()
      }).catch(() => {})
    },
    onUnapprove(row) {
      if (!this.isReceiveNone(row)) {
        this.$message.warning('仅未收货的申请可反审')
        return
      }
      this.$confirm('反审后将变回待审批，是否继续？', '反审', { type: 'warning' }).then(async () => {
        await unapproveMaterialReq(row.id)
        this.$message.success('已反审')
        this.load()
      }).catch(() => {})
    },
    isReceiveNone(row) {
      const s = row && row.receiveStatus
      return !s || s === 'NONE'
    },
    onReject(row) {
      this.$prompt('请输入驳回原因', '驳回', { inputPattern: /\S+/, inputErrorMessage: '请填写原因' })
        .then(async ({ value }) => {
          await rejectMaterialReq(row.id, value)
          this.$message.success('已驳回')
          this.load()
        }).catch(() => {})
    },
    async onReceive(row) {
      this.receiveLoading = true
      this.receiveVisible = true
      try {
        const res = await previewMaterialReceive(row.id)
        const d = res.data || {}
        const req = d.req || {}
        this.receiveForm = {
          reqId: req.id,
          reqNo: req.reqNo,
          remark: '',
          lines: (d.lines || []).map(l => ({
            reqLineId: l.reqLineId,
            materialName: l.materialName,
            spec: l.specs || l.spec || '',
            unit: l.unit,
            reqQty: l.reqQty,
            receivedQty: l.receivedQty,
            remainQty: l.remainQty,
            receiveQty: Number(l.remainQty),
            remark: ''
          }))
        }
        if (!this.receiveForm.lines.length) {
          this.$message.warning('没有可收货明细')
          this.receiveVisible = false
        }
      } catch (e) {
        this.receiveVisible = false
      } finally {
        this.receiveLoading = false
      }
    },
    removeReceiveLine(index) {
      this.receiveForm.lines.splice(index, 1)
      if (!this.receiveForm.lines.length) {
        this.$message.warning('已无收货明细，可关闭后下次再收')
      }
    },
    fillAllRemain() {
      this.receiveForm.lines.forEach(l => { l.receiveQty = Number(l.remainQty) })
    },
    async saveReceive() {
      if (!this.receiveForm.lines.length) {
        return this.$message.warning('请至少保留一行收货明细')
      }
      const lines = this.receiveForm.lines
        .filter(l => l.receiveQty && Number(l.receiveQty) > 0)
        .map(l => ({
          reqLineId: l.reqLineId,
          receiveQty: l.receiveQty,
          remark: (l.remark || '').trim() || undefined
        }))
      if (!lines.length) return this.$message.warning('请至少填写一行收货数量')
      this.saving = true
      try {
        const res = await createMaterialReceive({
          reqId: this.receiveForm.reqId,
          remark: this.receiveForm.remark,
          lines
        })
        const no = (res.data && res.data.receive && res.data.receive.receiveNo) || ''
        this.$message.success(no ? `已生成收货单 ${no}` : '已生成收货单')
        this.receiveVisible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    onDelete(row) {
      this.$confirm('确认删除该申请？', '提示', { type: 'warning' }).then(async () => {
        await deleteMaterialReq(row.id); this.$message.success('已删除'); this.load()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.pick-toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.tip { margin:8px 0 0; font-size:12px; color:#94a3b8; }
.detail-meta {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1fr);
  column-gap: 50px;
  row-gap: 8px;
  margin: 0 0 12px;
  line-height: 1.6;
  color: #334155;
}
.detail-meta > span {
  min-width: 0;
  word-break: break-all;
}
</style>
